<template lang="html">

    <div class="academico-edit row-start" v-if="!!acaedit" :clicked="clicked">
        <button class="erase" @click="erase"></button>

        <div class="inputs-wrapper nw row-start">

            <div class="contenedor-input -small" :error="errors.has('inicio')">
                <label for="">Comienzo</label>
                <datepicker v-model="inicio" :language="es"
                    :full-month-name="true" v-validate="'required'"
                    :monday-first="true" :format="'yyyy'" name="inicio"
                    :open-date="new Date()"
                    :minimum-view="'year'"></datepicker>
                <span :class="['error',{'animated shake' : clicked}]"
                    v-if="clicked">{{ errors.first('inicio') }}</span>
            </div>

            <div class="contenedor-input -small" :error="errors.has('fin')">
                <label for="">Fin</label>
                <datepicker v-model="fin" :language="es" :full-month-name="true"
                    :monday-first="true" :format="'yyyy'"
                    v-validate="'required'" :disabledDates="disabledDates"
                    :minimum-view="'year'" name="fin"></datepicker>
                <span :class="['error',{'animated shake' : clicked}]"
                    v-if="clicked">{{ errors.first('fin') }}</span>
            </div>

            <div class="contenedor-input" v-if="!!dominios">
                <label for="">Nombre del título</label>
                <select v-if="propio" name="titulacion" v-validate="'required'"
                    v-model="acaedit.idTitulacion" :disabled="!!data">
                    <option value="">Selecciona una titulación</option>
                    <option v-for="(titulacion,key) in dominios.titulaciones"
                        :value="titulacion.idTitulacion">{{titulacion.descripcion}}</option>
                </select>
                <input type="text" v-if="!!!propio" v-model="acaedit.titulacion"
                    name="titulacion" v-validate="'required'">
                <span :class="['error',{'animated shake' : clicked}]"
                    v-if="clicked">{{ errors.first('titulacion') }}</span>
            </div>

        </div>


        <div class="inputs-wrapper row-start" v-if="!propio">

            <div class="contenedor-input -small -nota">
                <label for="">Nota</label>
                <input type="text" name="nota" v-model="acaedit.Nota">
            </div>

            <div class="contenedor-input">
                <label for="">Centro</label>
                <input type="text" name="centro" v-model="acaedit.centro">
            </div>


        </div>


    </div>


</template>

<script lang="js">

    import Datepicker from 'vuejs-datepicker';

    import { en, es } from 'vuejs-datepicker/dist/locale'

    import {mapGetters, mapActions} from 'vuex';

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);


    export default {
        name: 'academico-edit',
        props : ['data', 'propio','clicked'],
        mounted(){
            if(!!this.data){

                this.acaedit = this.data;
                let inicio = new Date(this.acaedit.anioinicio,1,1);
                let fin = new Date(this.acaedit.Aniofin,1,1);
                this.inicio = inicio;
                this.fin = fin;

                this.acaedit.idTitulacion = this.data.idTitulacion;

                this.$validator.reset();

                setTimeout(e => {
                    this.checkData();
                },100)

            }else{


                this.inicio = new Date();
                this.fin = new Date();

                this.acaedit = {
                    id: null,
                    anioinicio: 0,
                    Aniofin: 0,
                    titulacion: null,
                    idTitulacion: 0,
                    cursoMasAlto: null,
                    asignaturasPracticas: null
                }
            }
        },
        data() {
            return {
                en: en,
                es: es,
                finalizacion: '',
                inicio: '',
                fin: '',
                acaedit : {
                    
                }
            }
        },
        computed:{
            ...mapGetters({
                dominios : 'getDominiosOrder'
            }),
            disabledDates(){
                let dates; 
                

                if(!!this.dominios & this.propio){

                    if(!!this.dominios.promociones){

                    let init = Number(Object.values(this.dominios.promociones)[0]);

                    let end = Number(Object.values(this.dominios.promociones).pop());

                    dates = {
                        to: new Date(init, 0, 1), 
                        from: new Date(end, 0, 1), 
                    }
                                
                    }
                }

                

                return dates;

            }
        },
        methods: {
            ...mapActions(['eraseAcademico','eraseOtroEstudio']),
            checkData(){
                this.$validator.validateAll().then(canSend => {

                        let inicio = new Date(this.inicio);
                        this.acaedit.anioinicio = inicio.getFullYear();

                        let fin = new Date(this.fin);
                        this.acaedit.Aniofin = fin.getFullYear();

                        this.acaedit.allok = canSend;

                        this.$emit('input', this.acaedit);
            
                });
            },
            erase(){

                if(!!this.data){
                    if(this.propio){
                        this.eraseAcademico(this.data.idTitulacion).then(r => {
                            this.$emit('erase',this.acaedit);
                            this.acaedit = false;
                        });
                    }else{
                            this.eraseOtroEstudio(this.data.id).then(r => {
                                this.$emit('erase',this.acaedit);
                                this.acaedit = false;
                            });
                    }
                }else{
                    this.$emit('erase',this.acaedit);
                    this.acaedit = false;
                }
            },
        },
        components: {
            Datepicker,
        },
        watch : {
            'acaedit': {
                deep: true,
                handler(){
                    this.checkData();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .erase {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 5;
    }

    .contenedor-input select[aria-invalid="true"], .contenedor-input input[aria-invalid="true"], .contenedor-input textarea[aria-invalid="true"]{
    background-color:transparent;
  }

  [clicked=true]{
  .contenedor-input select[aria-invalid="true"],
  .contenedor-input input[aria-invalid="true"],
  .contenedor-input textarea[aria-invalid="true"]{
    background-color: rgba(255,0,0,0.4);
  } 
  
}

  .inputs-wrapper.nw{
      flex-wrap: nowrap;
  }

  @media screen and (max-width: 705px){
    .inputs-wrapper.nw{
      flex-wrap: wrap;
    }   
  }

</style>


// WEBPACK FOOTER //
// src/components/parts/academico-edit.vue